import { createContext, useState } from 'react';

const INITIAL_CONFIG: boolean = false;

interface PluginsContextProps {
  initialValue: boolean;
  children: React.ReactNode;
}

const usePluginStoreData = (initialValue: boolean = INITIAL_CONFIG) => {
  const [isFinalizedPayment, setIsFinalizedPayment] = useState(initialValue);
  return {
    isFinalizedPayment,
    setIsFinalizedPayment,
  };
};

type UsePluginStoreDataType = ReturnType<typeof usePluginStoreData>;

const PluginsContext = createContext<UsePluginStoreDataType>(null as any);

const PluginsProvider = ({ children, initialValue }: PluginsContextProps) => (
  <PluginsContext.Provider value={usePluginStoreData(initialValue)}>{children}</PluginsContext.Provider>
);

export { PluginsContext, PluginsProvider };
